import { REACTION_TOKEN_SET } from './reactionEmojiMap';

/**
 * KAP-310 — single source for the per-user quick-react chip trio. Both the
 * presentational toolbar default fallback and the UnifiedChatPanel resolver
 * import from here so the default trio and validation rules cannot drift.
 *
 * The backend (`quick-react-chips-handler.js`) enforces the same shape:
 * exactly 3 tokens, every token in the canonical reaction-token-catalog
 * (`contracts/schemas/internal/reaction-token-catalog.schema.json`). The
 * resolver below mirrors that contract on the read side so an invalid
 * persisted value falls back to the default instead of crashing the bubble.
 */
export const DEFAULT_QUICK_REACT_TOKENS = Object.freeze(['check', 'eyes', 'raised_hands']);

export const QUICK_REACT_CHIP_COUNT = 3;

export function resolveQuickReactTokens(rawChips) {
  if (!Array.isArray(rawChips)) return DEFAULT_QUICK_REACT_TOKENS;
  if (rawChips.length !== QUICK_REACT_CHIP_COUNT) return DEFAULT_QUICK_REACT_TOKENS;
  for (const token of rawChips) {
    if (typeof token !== 'string' || token.length === 0) return DEFAULT_QUICK_REACT_TOKENS;
    if (!REACTION_TOKEN_SET.has(token)) return DEFAULT_QUICK_REACT_TOKENS;
  }
  // Reject duplicates — three slots with the same emoji is useless and
  // not a state the backend ever produces, but a stale row from before
  // the validation shipped could carry one.
  if (new Set(rawChips).size !== QUICK_REACT_CHIP_COUNT) return DEFAULT_QUICK_REACT_TOKENS;
  return rawChips;
}
